var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-490 -241)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6659ff",
    fillRule: "nonzero",
    d: "M498.85 241.435l1.928 4.065a.748.748 0 00.562.42l4.365.668a.75.75 0 01.42 1.267l-3.203 3.277a.753.753 0 00-.202.653l.78 4.215a.75.75 0 01-1.05.817l-3.938-1.792a.75.75 0 00-.622 0l-3.967 1.785a.752.752 0 01-1.05-.81l.75-4.17a.754.754 0 00-.203-.652l-3.203-3.293a.75.75 0 01.42-1.26l4.365-.668a.747.747 0 00.563-.457l1.935-4.065a.75.75 0 011.35 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.de9f3818.svg";
export { ForwardRef as ReactComponent };